// react、next
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Container, Loader, LoadingOverlay } from '@mantine/core';

// component
import GameDetail from 'components/GameDetail';

// store
import { setCurrentGame, setLoading } from '@/store/features/gameSlice';
import { wrapper } from '@/store';

// scss
import styles from './index.module.scss';

// api
import { getAllGames, getGameCover, getSimilarGames } from '@/api/header';

// utils，const
import { formatCover } from "@/utils/methods";

// 游戏详情页
export function GameDetailPage({ similarGames }) {
    const router = useRouter();
    const path = router.query.slug;
    const dispatch = useDispatch();
    const { currentGame, loading } = useSelector((state) => state.game);
    // 当前封面正在获取中
    const [gameCoverLoading, setGameCoverLoading] = useState(true);

    // 只在客户端路由变化时获取数据
    useEffect(() => {
        const fetchGameData = async () => {
            try {
                const res = await getAllGames({ query: `path:${path}` });
                if (res.data && res.data.results && res.data.results[0]) {
                    let gameRes = {...res.data.results[0], cover_image: "/images/icons/common/placeholder.jpg"};
                    dispatch(setCurrentGame(gameRes));

                    // 获取游戏封面
                    const params = {
                        game_ids: gameRes.id,
                    };
                    getGameCover(params).then((res) => {
                        // results是对象，key值为游戏id
                        const { results: gameCoversMap } = res.data;
                        let cover_image = gameCoversMap[gameRes.id];
                        if (cover_image) {
                            dispatch(setCurrentGame({...gameRes, cover_image: formatCover(cover_image)}))
                        }
                    });
                }
            } catch (error) {
                console.error('Failed to fetch game data:', error);
            } finally {
                dispatch(setLoading(false));
            }
        };
        dispatch(setLoading(true));

        fetchGameData();
    }, [path, router.isReady]);

    // 等待加载的element
    const loadingEle = (
        <div className={styles.container}>
            <LoadingOverlay
                visible={loading}
                zIndex={2000}
                overlayProps={{ radius: 'md', opacity: 0 }}
                loaderProps={{ color: 'white', type: 'bars' }}
            />
        </div>
    )

    if (loading) {
        return loadingEle;
    }

    if (!currentGame) {
        return loadingEle;
    } else {
        return (
            <>
                <GameDetail
                    game={currentGame}
                    gameCoverLoading={gameCoverLoading}
                    similarGamesProps={similarGames}
                />
            </>
        );
    }
}

// 添加服务端数据预取
export const getGamePageServerSideProps = wrapper.getServerSideProps(
    (store) => async (context) => {
        const { slug } = context.params;

        // 获取当前store状态中的menuData
        const state = store.getState();
        const { menuData } = state.game;

        try {
            const res = await getAllGames({ query: `path:${slug}` });
            if (res.data && res.data.results && res.data.results[0]) {
                let gameRes = {...res.data.results[0], cover_image: "/images/icons/common/placeholder.jpg"};
                store.dispatch(setCurrentGame(gameRes));

                // 获取游戏封面
                const params = {
                    game_ids: gameRes.id,
                };
                getGameCover(params).then((res) => {
                    // results是对象，key值为游戏id
                    const { results: gameCoversMap } = res.data;
                    let cover_image = gameCoversMap[gameRes.id];
                    if (cover_image) {
                        store.dispatch(setCurrentGame({...gameRes, cover_image: formatCover(cover_image)}))
                    }
                });

                // 相似游戏的获取
                const similarRes = await getSimilarGames({
                    game_path: gameRes.path,
                    limit: 10,
                    offset: 0,
                });
                let { results } = similarRes.data;
                return {
                    props: {
                        similarGames: results || [],
                    }
                };
            }
        } catch (error) {
            console.error('Failed to fetch game data:', error);
        }

        return {
            props: {
                similarGames: [],
            }
        };
    }
);